import { useState, useCallback } from 'react';
import { useJobStatus } from './useJobStatus';
import { plotsService } from 'lib';

/**
 * Hook to start bulk update and track its progress
 * 
 * @param {string} developmentId - The development ID
 * @returns {object} Functions and state for bulk update
 */
export function useBulkUpdate(developmentId) {
  const [jobId, setJobId] = useState(null);
  const [startingJob, setStartingJob] = useState(false);
  const [startError, setStartError] = useState(null);

  // Track job status (only when jobId exists)
  // const jobStatus = useJobStatus(developmentId, jobId, {
  //   enabled: !!jobId,
  //   onComplete: (job) => {
  //     console.log('✅ Bulk update completed!', job);
  //   },
  //   onError: (error) => {
  //     console.error('❌ Bulk update failed:', error);
  //   }
  // });

  // Start bulk update
  const startBulkUpdate = useCallback(async (plots, streetPins) => {
    setStartingJob(true);
    setStartError(null);

    try {
      const response = await plotsService.updateBulkPlot({plots: plots, streetPins: streetPins })
      console.log(response)
      if (!response.success) {
        // throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }

      const result = response.data.data;
      const newJobId = result.jobId;
      
      setJobId(newJobId);
      setStartingJob(false);
      
      return {
        success: true,
        jobId: newJobId,
        statusUrl: result.statusUrl,
        retryUrl: result.retryUrl
      };

    } catch (error) {
      console.error('[useBulkUpdate] Failed to start job:', error);
      setStartError(error.message);
      setStartingJob(false);
      
      return {
        success: false,
        error: error.message
      };
    }
  }, [developmentId]);

  // Reset state
  const reset = useCallback(() => {
    setJobId(null);
    setStartError(null);
    // jobStatus.stopPolling();
  }, []);

  return {
    // Start function
    startBulkUpdate,
    
    // Job tracking
    jobId,
    // ...jobStatus,
    
    // Start status
    startingJob,
    startError,
    
    // Utils
    reset
  };
} 